// extracted by mini-css-extract-plugin
module.exports = {"title":"disclosures_title__4ydc3","disclosure":"disclosures_disclosure__Kz_F7"};